import { NgModule } from '@angular/core';
import { NavComponent } from './nav/nav.component';
import { LoaderComponent } from './loader/loader.component';
import { ManageHotspotsGuard } from './guards/manage-hotspots.guard';
import { ManagePermissionsGuard } from './guards/manage-permissions.guard';
import { ManageRolesGuard } from './guards/manage-roles.guard';
import { ManageUsersGuard } from './guards/manage-users.guard';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { ManageCarriersGuard } from './guards/manage-carriers.guard';
import { ManageDriversGuard } from './guards/manage-drivers.guard';
import { MonitoringGuard } from './guards/monitoring.guard';
import { ModalComponent } from './modal/modal.component';
import { PasswordChangeCallbackComponent } from './password-change-callback/password-change-callback.component';
import { PendingChangesGuard } from './guards/pending-changes.guard';
import { PendingChangesActionGuard } from './guards/pending-changes-action.guard';
import { HomeComponent } from './home/home.component';
import { CORE_ROUTES } from './core.routes';
import { OverviewGuard } from './guards/overview.guard';
import { LoadTrackingGuard } from './guards/load-tracking.guard';
import { ReadLogEventsGuard } from './guards/read-log-events.guard';
import { ManageLocalLoadsGuard } from './guards/manage-local-loads.guard';
import { ManageLoadHandoversGuard } from './guards/manage-load-handovers.guard';
import { ManageLocationsGuard } from './guards/manage-locations.guard';
import { ManageCarrierSubcontractorsGuard } from './guards/manage-carrier-subcontractors.guard';
import { ManageSubcontractorsGuard } from './guards/manage-subcontractors.guard';
import { LogoutComponent } from './logout/logout.component';
import {WebhooksEventsGuard} from './guards/webhooks-events.guard';
import {PodsValidationGuard} from './guards/pods-validation.guard';
import {LanguagePickerComponent} from '../shared/language-picker/language-picker.component';
import { FullscreenModalComponent } from './fullscreen-modal/fullscreen-modal.component';
import { ManageBlueyonderUserGuard } from './guards/manage-blueyonder-user-guard.service';
import { WidgetPodCarrierManagerComponent } from './widgets/widget-pod/widget-pod-carrier-manager.component';
import { WidgetButtonComponent } from './widgets/widget-button/widget-button.component';
import { WidgetPodChepManagerComponent } from './widgets/widget-pod-chep-manager/widget-pod-chep-manager.component';
import { WidgetLoaderComponent } from './widgets/shared/widget-loader/widget-loader.component';
import {ManageUserSearchGuard} from './guards/manage-user-search.guard';
import { ManageCarrierManagersGuard } from './guards/manage-carrier-managers-guard.service';

@NgModule({
  imports: [
    RouterModule.forChild(CORE_ROUTES),
    SharedModule
  ],
  declarations: [
    LoaderComponent,
    NavComponent,
    LogoutComponent,
    ModalComponent,
    PasswordChangeCallbackComponent,
    HomeComponent,
    LanguagePickerComponent,
    FullscreenModalComponent,
    WidgetPodCarrierManagerComponent,
    WidgetButtonComponent,
    WidgetPodChepManagerComponent,
    WidgetLoaderComponent
  ],
  exports: [
    LoaderComponent,
    NavComponent,
    ModalComponent,
    FullscreenModalComponent
  ],
  providers: [
    ManageUsersGuard,
    ManageRolesGuard,
    ManagePermissionsGuard,
    ManageUserSearchGuard,
    ManageCarriersGuard,
    ManageDriversGuard,
    ManageCarrierManagersGuard,
    ManageHotspotsGuard,
    ManageLoadHandoversGuard,
    ManageLocalLoadsGuard,
    ManageLocationsGuard,
    ManageCarrierSubcontractorsGuard,
    ManageSubcontractorsGuard,
    ManageBlueyonderUserGuard,
    MonitoringGuard,
    LoadTrackingGuard,
    OverviewGuard,
    PendingChangesGuard,
    PendingChangesActionGuard,
    ReadLogEventsGuard,
    WebhooksEventsGuard,
    PodsValidationGuard
  ]
})
export class CoreModule {
}
